import { combineReducers } from "redux";
import { applicationReducer } from "./applicationReducer";
import { seekReducer } from "./seekReducer";
import { datasetReducer } from "./dataseekReducer";

const appReducer = combineReducers({
  application: applicationReducer,
  seek: seekReducer,
  dataset: datasetReducer
});

export const rootReducer = (state: any, action: any) => {
  return appReducer(state, action);
};